<script lang="ts">
  import { onMount } from "svelte";
  import { params } from "@roxi/routify";
  import SalesforceChat from "@shared/services/salesforce_chat";
  import Spinner from "@shared/svelte/Components/SpinnerInternal.svelte";
  import { HttpPromise, HttpPromiseWithEntireResponse } from "@shared/svelte/Modules/ApiService";
  import OrdersView from "@modern/components/distributor/OrdersView.svelte";
  import * as _ from "lodash";
  import type { SharedOrder } from "@shared/types/Order";

  let paginationLimit = 50;
  let paginationEntries = 0;

  onMount(() => {
    SalesforceChat.initialize();
  });

  const ordersRes = async incoming => {
    let paramsToSend = _.merge($params, incoming);
    paramsToSend.page = paramsToSend.orderPage;
    let res = await HttpPromiseWithEntireResponse({
      method: "GET",
      url: "/api/distributor/orders",
      data: _.merge(paramsToSend, { includeEvents: true, restrictToSingleDistributor: true }),
    });
    if (res.ok) {
      paginationEntries = Number(res.headers.get("X-Pagination-Entries"));
      paginationLimit = Number(res.headers.get("X-Pagination-Limit"));
      return res.json();
    } else {
      return [];
    }
  };

  const assignmentsRes = async () => {
    return HttpPromise({
      method: "GET",
      url: "/api/distributor/sales_rep_vacations/assignments",
    });
  };

  const managersRes = async () => {
    return HttpPromise({
      method: "GET",
      url: "/api/distributor/sales_reps",
      data: { managed: true },
    });
  };

  let loadedData;

  const load = async ordersParams => {
    const orders = ordersRes(ordersParams);
    const managers = managersRes();
    const assignments = assignmentsRes();
    const results = await Promise.all([managers, orders, assignments]);
    loadedData = {
      managers: results[0] as unknown as any[],
      orders: results[1] as unknown as SharedOrder[],
      assignments: (results[2] as unknown as any[]) || [],
    };
  };
</script>

{#await load({})}
  <Spinner />
{:then}
  {#key loadedData}
    {#if loadedData.assignments.length}
      <div class="padding--small vacation-assignments background-yellow">
        <div class="grid-container">
          <div class="grid-row">
            <div class="grid-col c12-12 light-body--regular">
              <span
                >You are currently assigned to cover the following sales reps who are out of office:</span
              >
              {#each loadedData.assignments as assignment}
                <span>{assignment.name}</span>
              {/each}
            </div>
          </div>
        </div>
      </div>
    {/if}

    <div class="distributor-page">
      <OrdersView
        ordersRes={loadedData.orders}
        {paginationLimit}
        {paginationEntries}
        managed={loadedData.managers}
        {load}
      />
    </div>
  {/key}
{/await}
